import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TiimeOptionModule, TiimeInputContainerModule, TiimeSelectModule } from 'tiime-material';

import { SelectBase } from '@bases/selector/select.base';
import { TiimeBusinessProAccountIntention } from '@gi/enums/tiime-business-pro-account-intention.enum';
import { CodeAndLabel } from '@models/code-and-label';
import { TiimeBusinessProAccountIntentionIconComponent } from '@shared-components/tiime-business-pro-account-intention-icon/tiime-business-pro-account-intention-icon.component';

@Component({
  selector: 'app-tiime-business-pro-account-intention-select',
  standalone: true,
  imports: [
    TiimeOptionModule,
    TiimeBusinessProAccountIntentionIconComponent,
    ReactiveFormsModule,
    TiimeSelectModule,
    TiimeInputContainerModule
  ],
  templateUrl: './tiime-business-pro-account-intention-select.component.html',
  styleUrl: './tiime-business-pro-account-intention-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TiimeBusinessProAccountIntentionSelectComponent extends SelectBase<
  CodeAndLabel<TiimeBusinessProAccountIntention>
> {
  @Input({ required: true }) options: CodeAndLabel<TiimeBusinessProAccountIntention>[];
  @Input() label: string = 'Intérêt compte pro Tiime';
}
